import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Select from 'react-select'
import DatePicker from "react-datepicker"
import { Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'

import { store } from 'store/index'
import { showLoader, hideLoader } from 'store/loader/actions'
import ReactSelect from 'pages/parts/ReactSelect'
import { httpOk, GET, POST, PUT, DELETE } from 'helpers/api'
import { formatDate, formatMoney, returnMinDate, formatMoneyInput } from 'helpers/helpers'

function CreateUpdate() {
	const { t } = useTranslation()
	const navigate = useNavigate()

	const tbodyRef = useRef()
	const scrollRef = useRef()
	const refs = useRef([]);
	const inputRefs = useRef([]);

	const reduxAccount = useSelector(state => state.account)

	const [wms, setWms] = useState([])
	const [items, setItems] = useState([])
	const [ingredients, setIngredients] = useState({})
	const [employees, setEmployees] = useState([])
	const [addQuantity, setAddQuantity] = useState(1)
	const [elementsDuplicate, setElementsDuplicate] = useState([])
	const [modalTemplate, setModalTemplate] = useState({ 'bool': false, 'templates': [] })
	const [modalSelectProduct, setModalSelectProduct] = useState({ 'show': false, 'children': [] });
	const [data, setData] = useState({
		"items": [],
		"total_cost_amount": 0,
		"total_sale_amount": 0,
		"note": null,
		// "user_login": reduxAccount.login,
		"user_login": "",
		"activeIndex": null,
		"created_at": formatDate(new Date(), 'yyyy-MM-dd'),
	})

	async function createUpdate() {
		var dataCopy = { ...data }

		if (dataCopy.items.length === 0) {
			toast.error(t('add_elements'))
			return
		}

		for (let i = 0; i < dataCopy.items.length; i++) {
			if (!dataCopy.items[i]['quantity']) {
				dataCopy.error = true
			}
		}

		var valueArr = dataCopy.items.map(function (item) { return item.id });
		var isDuplicate = valueArr.some(function (item, idx) {
			return valueArr.indexOf(item) !== idx
		});

		if (isDuplicate) {
			toast.error(t('identical_elements'))
			return
		}

		if (dataCopy.error) {
			toast.error(t('check_filled_inputs'))
			return
		}

		var response = await sendDocument(dataCopy)

		/* Tannarx sakrashi — tasdiq so'rab qayta yuborish (2026-08-15).
		   Asosiy bo'limdagi bilan bir xil, izoh: main/documentsPreparation/CreateUpdate.js */
		if (response?.status === 400 && response?.data?.code === 'cost_price_jump') {
			if (!window.confirm(response.data.message)) return
			response = await sendDocument({ ...dataCopy, cost_confirmed: 1 })
		}

		if (httpOk(response)) {
			navigate('/workshop/documents-preparation')
		}
	}

	async function sendDocument(body) {
		if (body.id) {
			return await PUT('/documents-preparation', body, { loader: true })
		}
		return await POST('/documents-preparation', body, { loader: true })
	}

	function onKeyPress(e, index) {
		var dataCopy = { ...data }
		var currentProduct = dataCopy.items[index];
		console.log(e.key);

		if ((e.key === 'Tab' || e.key === 'Enter') && currentProduct.product_type === 4) {
			addToList(1, currentProduct);
		}
	}

	function addToList(length = 1, item = {}) {
		var dataCopy = JSON.parse(JSON.stringify(data))

		for (let i = 0; i < length; i++) {
			dataCopy.items.push({
				'price': '',
				'quantity': '',
				'element_id': '',
				...item,
			})
		}
		dataCopy.activeIndex = dataCopy.items.length - 1;
		countTotalAmount(dataCopy)

		setTimeout(() => {
			if (item?.balance_id) {
				inputRefs.current[dataCopy.activeIndex]?.focus()
			} else {
				refs.current[dataCopy.activeIndex]?.focus()
			}
		}, 50);
	}

	function deleteItem(index) {
		var dataCopy = JSON.parse(JSON.stringify(data))
		dataCopy.items.splice(index, 1)
		dataCopy.activeIndex = null

		countTotalAmount(dataCopy)
	}

	function countTotalAmount(dataCopy) {
		dataCopy.total_quantity = 0;
		dataCopy.total_cost_amount = 0;
		dataCopy.total_sale_amount = 0;

		for (let i = 0; i < dataCopy.items.length; i++) {
			dataCopy.total_quantity += Number(dataCopy.items[i]['quantity'])
			dataCopy.total_cost_amount += Number(dataCopy.items[i]['quantity']) * Number(dataCopy.items[i]['cost_price'])
			dataCopy.total_sale_amount += Number(dataCopy.items[i]['quantity']) * Number(dataCopy.items[i]['sale_price'])
		}
		console.log(dataCopy.items);

		setData(dataCopy);
	}

	function handleInputChange(e, index) {
		var dataCopy = { ...data }
		dataCopy.items[index][e.target.name] = e.target.value.replace(/[^0-9.]/g, '')
		if ((e.target.name === 'element_quantity' || e.target.name === 'quantity') && dataCopy.items[index].product_type === 1) {
			/* ⚠️ Dona soni 0 yoki bo'sh bo'lsa BO'LMAYMIZ — Infinity/NaN tannarx sifatida
			   saqlanib katalog narxini buzardi (2026-08-15). */
			const qty = Number(dataCopy.items[index].quantity)
			if (qty > 0) {
				dataCopy.items[index].cost_price = Math.round(dataCopy.items[index].element_cost_price * dataCopy.items[index].element_quantity / qty);
				dataCopy.items[index].sale_price = Math.round(dataCopy.items[index].cost_price + Number(dataCopy.items[index].markup ?? 0))
			} else {
				dataCopy.items[index].cost_price = ''
				dataCopy.items[index].sale_price = ''
			}
		}

		countTotalAmount(dataCopy)
	}

	function handleChangeSelect(index, value) {
		var dataCopy = { ...data }

		dataCopy.items[index].balance_id = value.balance_id;
		dataCopy.items[index].balance = value.balance;
		dataCopy.items[index].element_id = value.product_id;
		dataCopy.items[index].element_name = value.product_name;
		dataCopy.items[index].element_sale_price = value.sale_price;
		dataCopy.items[index].element_cost_price = value.price;
		dataCopy.items[index]['quantity'] = '';
		// dataCopy.items[data.activeIndex]['ingredients'][index] = value;
		// dataCopy.items[data.activeIndex]['ingredients'][index]['quantity'] = '';
		setModalSelectProduct({ ...modalSelectProduct, show: false })
		countTotalAmount(dataCopy)

		setTimeout(() => {
			inputRefs.current[dataCopy.activeIndex]?.focus()
		}, 150);
	}

	// REACT SELECT LOGIC
	function handleSelectSearch(value) {
		if (!value) return
		var elementsDuplicateCopy = [...elementsDuplicate]

		var filteredItems = elementsDuplicateCopy.filter(item => item.name.toLowerCase().includes(value.toLowerCase()))
		if (filteredItems[0]) {
			filteredItems[0]['selected'] = true
		}
		setItems(filteredItems)
	}

	async function handleSelectItem(option, index) {
		var dataCopy = { ...data }
		dataCopy.items[index].id = option.product_id;
		dataCopy.items[index].product_id = option.product_id;
		dataCopy.items[index].product_name = option.name;
		dataCopy.items[index].product_balance = option.balance;
		dataCopy.items[index].product_type = option.product_type;
		dataCopy.items[index].width = option.width;
		dataCopy.items[index].length = option.length;
		dataCopy.items[index].sale_price = option.sale_price

		if (dataCopy.items[index].product_type === 4) {
			// dataCopy.items[index].cost_price = dataCopy.items[index].element_cost_price
			dataCopy.items[index].cost_price = dataCopy.items[index].element_sale_price
		} else {
			dataCopy.items[index].cost_price = Math.round(Number(dataCopy.items[index].element_cost_price) / (option.length / Number(option.width)))
		}

		if (dataCopy.items[index].cost_price) {
			if (dataCopy.items[index].product_type === 4) {
				dataCopy.items[index].sale_price = dataCopy.items[index].cost_price + Number(option.markup)
			} else {
				dataCopy.items[index].sale_price = dataCopy.items[index].cost_price + Number(option.markup / (option.length / Number(option.width)))
			}
		}

		// const response = await GET(`/documents-preparation-product-ingredients?product_id=${option.id}&wms_id=${data.wms_id}`, {}, { loader: true })
		// if (httpOk(response)) {
		// 	dataCopy.items[index]['ingredients'] = response.data
		// }

		countTotalAmount(dataCopy)
	}

	function closeMenu() {
		setTimeout(() => {
			var elementsCopy = [...items]
			for (let i = 0; i < elementsCopy.length; i++) {
				elementsCopy[i].selected = false
			}
			elementsCopy[0].selected = true
			setItems(elementsCopy)
		}, 100);
	}

	function handleTableKeyDown(event) {
		event.stopPropagation();
		var currentIndex = items.findIndex(el => el.selected);
		if (currentIndex >= 0) {
			var elementsCopy = [...items]
			elementsCopy[currentIndex].selected = false
			switch (event.key) {
				case "ArrowUp":
					if (currentIndex === 0) {
						elementsCopy[items.length - 1].selected = true
						currentIndex = items.length - 1
					} else {
						elementsCopy[currentIndex - 1].selected = true
					}
					scrollRef.current.scrollTop = (currentIndex * 29.6) - 59.2
					break;
				case "ArrowDown":
					if (currentIndex === items.length - 1) {
						elementsCopy[0].selected = true
						currentIndex = 0
					} else {
						elementsCopy[currentIndex + 1].selected = true
					}
					scrollRef.current.scrollTop = (currentIndex * 29.6)
					break;
				default: break;
			}

			setItems(elementsCopy)
		}
	}
	// REACT SELECT LOGIC

	// TEMPLATE LOGIC

	async function toggleModalTemplate(bool) {
		if (bool) {
			const response = await GET(`/documents-preparation-templates?wms_id=${data.wms_id}`, {}, { loader: true })
			if (httpOk(response)) {
				setModalTemplate({ ...modalTemplate, 'bool': bool, 'templates': response })
			}
		} else {
			setModalTemplate({ ...modalTemplate, 'bool': bool, 'templates': [] })
		}
	}

	function handleSelectTemplate(item) {
		setData({ ...data, items: item.items })
		toggleModalTemplate(false)
	}

	async function deleteTemplate(item) {
		await DELETE(`/documents-preparation-templates/${item.document_order_id}`, {}, { loader: true })
		toggleModalTemplate(false)
	}
	// TEMPLATE LOGIC

	async function getData() {
		store.dispatch(showLoader());

		var response
		response = await GET(`/helper/wms`, {}, { loader: true })
		if (httpOk(response)) setWms(response.data)

		response = await GET(`/helper/employees`, {}, { loader: true })
		if (httpOk(response)) setEmployees(response.data)

		store.dispatch(hideLoader());
	}

	async function getProducts() {
		const response = await GET(`/documents-preparation-products`, {}, { loader: true })
		if (httpOk(response)) {
			setItems(response.data)
			setElementsDuplicate(response.data)
		}
	}

	async function getIngredients() {
		const response = await GET(`/documents-preparation-ingredients`, {}, { loader: true })
		if (httpOk(response)) {
			setIngredients(response.data)
		}
	}

	useEffect(() => {
		getData()
		getProducts()
		getIngredients()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	function getProductsList() {
		var arr = modalSelectProduct.children;

		if (modalSelectProduct.search) {
			arr = arr.filter(item =>
				item.name.toLowerCase().includes(modalSelectProduct.search.toLowerCase())
			);
		}

		return arr;
	}


	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<div className="d-flex text-truncate">
					<h4 className="vertical-center">
						{t('preparation')}
					</h4>
					<div className="vertical-center mt-1">
						<i className="uil uil-angle-double-right fz-20"></i>
					</div>
					<div className="vertical-center mt-1">
						<h6>{t('create')}</h6>
					</div>
				</div>
				<div className="d-flex gap-1">
					<button type="button" className="btn btn-primary btn-rounded"
						onClick={() => toggleModalTemplate(true)}>
						{t('templates')}
					</button>
				</div>
			</div>

			<form autoComplete="off">
				<div className="card mb-3">
					<div className="card-body">
						<div className="row">
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('date')}<span className="required-mark">*</span></label>
									<div className="calendar-input">
										<DatePicker
											className="form-control"
											dateFormat="dd.MM.yyyy"
											selected={data.created_at ? new Date(data.created_at) : ''}
											onChange={(date) => setData({ ...data, 'created_at': formatDate(date, 'yyyy-MM-dd') })}
											minDate={returnMinDate(new Date(), reduxAccount.backdate ?? 3)}
											maxDate={new Date()} />
										<i className="uil uil-calendar-alt"></i>
									</div>
								</div>
							</div>
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('warehouse')}<span className="required-mark">*</span></label>
									<Select
										options={wms}
										value={wms.find(option => option.id === data.wms_id)}
										onChange={(option) => {
											setData({ ...data, 'wms_id': option.id })
										}}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>
							</div>
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('employee')}<span className="required-mark">*</span></label>
									<Select
										options={employees}
										value={employees.find(option => option.id === data.user_login)}
										onChange={(option) => setData({ ...data, 'user_login': option.login })}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.login}
									/>
								</div>
							</div>
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('note')}</label>
									<input type="text" className="form-control"
										name="note"
										onChange={(e) => setData({ ...data, 'note': e.target.value })} />
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="card" style={{ 'height': 'calc(100vh - 240px)' }}>
					<div className="card-body d-flex flex-column justify-content-between">
						<div>
							<table className="table table-bordered" style={{ 'overflow': 'unset' }}>
								<thead>
									<tr>
										<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
										<th style={{ 'width': '45%' }}>{t('roll')}</th>
										<th style={{ 'minWidth': '70px' }} className="text-end">{t('metr')}<span className="required-mark">*</span></th>
										<th style={{ 'width': '45%' }}>{t('product')}</th>
										<th style={{ 'minWidth': '70px' }} className="text-end">{t('quantity')}<span className="required-mark">*</span></th>
										<th style={{ 'minWidth': '33px' }} className="text-end"></th>
									</tr>
								</thead>
								<tbody>
									{data?.items?.map((item, index) => (
										<tr key={index}>
											<td className="text-center">
												{index + 1}
											</td>
											<td className="p-0">
												<Select
													classNamePrefix="border-none bs-none"
													options={ingredients.categories}
													value={ingredients.rolls.find(option => option.balance_id === item.balance_id) ?? ''}
													onChange={(option) => setModalSelectProduct({ show: true, index: index, children: option.products })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => `${option.name} (${option?.products?.length ? option.products.length : formatMoney(option.balance)})`}
													getOptionValue={(option) => option.balance_id}
													openMenuOnFocus={true}
													ref={(el) => (refs.current[index] = el)}
												/>
											</td>
											<td className="td-input"
												style={!item.element_quantity ? { 'borderBottom': '2px solid red' } : {}}>
												<input
													type="text"
													name="element_quantity"
													className="form-control text-end"
													placeholder="0"
													value={formatMoneyInput(item.element_quantity) ?? ''}
													onChange={(e) => handleInputChange(e, index)}
													ref={(el) => inputRefs.current[index] = el} />
											</td>
											<td className="p-0">
												<ReactSelect
													className="second"
													search={handleSelectSearch}
													value={`${item.product_name ? `${item.product_name} (${formatMoney(item.product_balance ?? 0)})` : ''}`}
													index={index}
													scrollRef={scrollRef}
													options={items}
													onKeyUp={(e) => {
														if (e.keyCode === 40 || e.keyCode === 38) {
															handleTableKeyDown(e)
														}
													}}
													onClose={() => closeMenu()}
													selectItem={(option) => handleSelectItem(option, index)}
													table={
														<table className="table mb-0">
															<tbody ref={tbodyRef}>
																{items.map((item2, index2) => (
																	<tr
																		id={item2.id}
																		className={"cursor " + ((item2.selected || item2.id === item.product_id) ? 'selected' : '')}
																		tabIndex={-1}
																		key={index2}
																		onClick={() => handleSelectItem(item2, index)}
																		onKeyDown={(e) => handleTableKeyDown(e, item2, index)}>
																		<td style={{ 'width': '50%' }}>{item2.name}</td>
																		<td style={{ 'width': '25%' }} className="text-end text-nowrap">{item2.product_type_name}</td>
																		<td style={{ 'width': '25%' }} className="text-end text-nowrap">{formatMoney(item2.balance)}</td>
																	</tr>
																))}
															</tbody>
														</table>
													}
												/>
											</td>
											<td className="td-input" style={!item.quantity ? { 'borderBottom': '2px solid red' } : {}}>
												<input
													type="text"
													name="quantity"
													className="form-control text-end"
													placeholder="0"
													value={formatMoneyInput(item.quantity) ?? ''}
													onChange={(e) => handleInputChange(e, index)}
													onKeyDown={(e) => onKeyPress(e, index)} />
											</td>
											<td className="vertical-middle">
												<div className="d-flex justify-content-end">
													<div className="table-action-button table-action-danger-button"
														onClick={() => deleteItem(index)}>
														<i className="uil uil-times"></i>
													</div>
												</div>
											</td>
										</tr>
									))}
									<tr>
										<td className="td-input">
											<input
												type="text"
												className="form-control text-center"
												style={{ 'padding': '5px 0' }}
												placeholder="xxx"
												value={addQuantity}
												onChange={(e) => setAddQuantity(e.target.value.replace(/[^0-9.]/g, ''))}
											/>
										</td>
										<td style={{ 'padding': 0 }}>
											<button type="button" className="btn-sm btn-primary w-100 h-100"
												style={{ minHeight: '36px' }}
												disabled={!(data.wms_id && data.user_login)}
												onClick={() => {
													setAddQuantity(1)
													addToList(addQuantity)
												}}>
												{t('add')}
											</button>
										</td>
										<td></td>
										<td></td>
										<td className="text-end">
											<b>{formatMoney(data.total_quantity)}</b>
										</td>
										<td></td>
									</tr>
								</tbody>
							</table>
						</div>

						<div className="d-flex justify-content-end gap-2">
							<Link to="/workshop/documents-preparation"
								className="btn btn-warning btn-rounded btn-wide"
								tabIndex="-1">
								{t('cancel')}
							</Link>
							<button type="button" className="btn btn-primary btn-rounded btn-wide" tabIndex="-1"
								onClick={() => createUpdate(1)}>
								{t('save')}
							</button>
						</div>
					</div>
				</div>
			</form>

			<Modal show={modalSelectProduct.show} animation={false} centered size="lg"
				onHide={() => setModalSelectProduct({ ...modalSelectProduct, show: false })}>
				<Modal.Body>
					<div className="addition-wrapper no-scroll">
						<div className="mb-2">
							<label>{t('search')}</label>
							<input autoFocus type="text" className="form-control"
								onChange={(e) => setModalSelectProduct({ ...modalSelectProduct, search: e.target.value })} />
						</div>

						<div>
							<table className="table table-bordered table-hover">
								<thead>
									<tr>
										<th>{t('name2')}</th>
										<th>{t('unit')}</th>
										<th className="text-end">{t('quantity')}</th>
										<th className="text-end">{t('balance2')}</th>
										<th className="text-center">{t('date')}</th>
										<th className="text-end">{t('supplier')}</th>
										<th className="text-center">{t('status')}</th>
									</tr>
								</thead>
								<tbody>
									{getProductsList().map((item, index) => (
										<tr key={index}
											className={`cursor`}
											onClick={() => handleChangeSelect(modalSelectProduct.index, item)}>
											<td>{item.name}</td>
											<td>{item.unit_name}</td>
											<td className="text-end">{item.quantity}</td>
											<td className="text-end">{formatMoney(item.balance, 3)}</td>
											<td className="text-center">{formatDate(item.created_at)}</td>
											<td className="text-end">{item.supplier_name}</td>
											<td className={`text-center text-white ${item.balance === item.quantity ? 'bg-info' : 'bg-primary'}`}>
												{item.balance === item.quantity ? t('new') : t('open')}
											</td>
										</tr>
									))}

								</tbody>
							</table>
						</div>

					</div>
				</Modal.Body>
			</Modal>

			{/* MODAL TEMPLATE */}
			<Modal show={modalTemplate.bool} animation={false} centered
				dialogClassName="update-modal-width" onHide={() => toggleModalTemplate(false)
				}>
				<Modal.Header closeButton>
					<Modal.Title>{t('templates')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive">
						<table className="table table-bordered table-hover cursor mb-0">
							<thead>
								<tr>
									<th style={{ 'width': '10px' }}>#</th>
									<th>{t('name2')}</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								{modalTemplate?.templates?.map((item, index) => (
									<tr key={index}>
										<td>{index + 1}</td>
										<td onClick={() => handleSelectTemplate(item)}>
											{item.name}
										</td>
										<td>
											<div className="d-flex justify-content-end">
												<div className="table-action-button table-action-danger-button"
													onClick={() => deleteTemplate(item)}>
													<i className="uil uil-times"></i>
												</div>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL TEMPLATE */}
		</>
	)
}

export default CreateUpdate